import { get } from 'lodash';
import ApiService from '@/services/apiService';

export default {
  data: function () {
    return {
      hasDeviceLimit: false,
      bridgeTypesMapping: {
        wmbus: 'bridge-wireless-mbus-decoder',
        lwm2m: 'bridge-lwm2m-server',
      },
      moduleKeys: {
        wmbus: 'wMBus',
        lwm2m: 'LwM2M',
      },
      limitExceededFlags: {
        wmbus: 'wmbusLimitExceeded',
        lwm2m: 'lwm2mLimitExceeded',
      },
    };
  },
  methods: {
    async checkLimits(bridgeType, moduleKey, limitExceededFlag) {
      try {
        const [virtualDevices, tenantModules] = await Promise.all([
          ApiService.fetchVirtualDevicesByBridgeType(this.selectedAccount, bridgeType),
          ApiService.tenantFetchModules(this.selectedAccount),
        ]);

        const module = tenantModules.find((m) => m.key === moduleKey);
        const hasActiveModule = module.isEnabled;

        this.hasDeviceLimit = get(module, 'settings.activeDeviceLimit');
        if (moduleKey === this.moduleKeys.wmbus) {
          this.hasDeviceLimit = !hasActiveModule;
        }

        const numberOfDevices = virtualDevices[0].count;
        const limit = get(module, 'settings.deviceLimit', 0);
        if (!hasActiveModule || (this.hasDeviceLimit && parseInt(numberOfDevices) >= parseInt(limit))) {
          this[limitExceededFlag] = true;
        }
        if (hasActiveModule && this.hasDeviceLimit) {
          this.remainingDevices = parseInt(limit) - parseInt(numberOfDevices);
        }
      } catch (error) {
        this.hasDeviceLimit = true;
        console.error(error);
      }
    },
  },
};
